import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class GraphService {
    constructor(private http: HttpClient) {

    }

    getFarmselect(id: string): Promise<any> {

		return this.http.get<any>(`${environment.API}${environment.URL_GET_FARM_SELECT}?orgId=${id}`)
			.pipe(map(res => {
				return { ...res };
			})).toPromise();
	}

    getPlotDashboard(id:string): Promise<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_PLOT_DASHBOARD}?farmId=${id}`)
			.pipe(map(res => {
				return { ...res };
			})).toPromise();
    }

    getPackage(packageId): Promise<any> {
        return this.http.get<any>(`${environment.API_GRAPH}${environment.URL_GET_PACKAGE}/${packageId}`)
        .pipe(map(res => {
            return { ...res };
        })).toPromise();
    }

    getSensorData(thingId: string, senserId: string, receive_date: string): Promise<any>{
        let date = this.convertDate(receive_date);

        return this.http.get<any>(`${environment.API_GRAPH}${environment.URL_GET_SENSOR_DATA}/${thingId}?sensor_id=${senserId}&receive_date_from=${date.from}&receive_date_to=${date.to}`)
        .pipe(map(res => {
            return { ...res };
        })).toPromise();
    }

    getReportData(thingId: string, filter?): Promise<any>{
        
        return this.http.get<any>(`${environment.API_GRAPH}${environment.URL_GET_REPORT_HISTORY}/${thingId}`, {
            params: { 
                duration: filter.duration,
                sensor_id: filter.sensor_id,
                type: filter.type,
                fromTime: filter.fromTime,
                toTime: filter.toTime,
             },
          })
        .pipe(map(res => {
            return { ...res };
        })).toPromise();
    }

    getDropdownDashboard(): Promise<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_DROPDOWN_CHILDORG_FARM}`)
        .pipe(map(res => {
            return { ...res };
        })).toPromise();
    }

    exportSensorData(thingId: string, senserId: string, receive_date: string, type: string): Promise<any>{
        let date = this.convertDate(receive_date);
        if(type == 'xlsx'){
            return this.http.get<any>(`${environment.API_GRAPH}${environment.URL_GET_SENSOR_DATA}/${thingId}/export/${type}?sensor_id=${senserId}&receive_date_from=${date.from}&receive_date_to=${date.to}`, {observe: 'response', responseType:'blob' as 'json'})
            .pipe(map(res => {
                return res;
            })).toPromise();
        }else{
            return this.http.get(`${environment.API_GRAPH}${environment.URL_GET_SENSOR_DATA}/${thingId}/export/${type}?sensor_id=${senserId}&receive_date_from=${date.from}&receive_date_to=${date.to}`, { responseType:'text'})
            .pipe(map(res => {
                return res;
            })).toPromise();
        }
    }

    exportReportData(thingId: string, type: string, filter?): Promise<any>{ 

        if(type == 'xlsx'){
            return this.http.get<any>(`${environment.API_GRAPH}${environment.URL_GET_REPORT_HISTORY}/${thingId}/export/${type}`, {
                observe: 'response', 
                responseType:'blob' as 'json',
                params: { ...filter },
              })
            .pipe(map(res => {
                return res;
            })).toPromise();
        }else{
            return this.http.get(`${environment.API_GRAPH}${environment.URL_GET_REPORT_HISTORY}/${thingId}/export/${type}`, {
                responseType:'text' as 'json',
                params: { ...filter },
              })
            .pipe(map(res => {
                return res;
            })).toPromise();
        }
    }


    convertDate(receive_date){
        return {
            from: moment(receive_date.split(" -")[0], 'DD MMM YYYY').set({'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0}).format('YYYY-MM-DDTHH:mm:ss'),
            to:moment(receive_date.split("- ")[1], 'DD MMM YYYY').set({'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 0}).format('YYYY-MM-DDTHH:mm:ss')
        }
    }
}